//#region Util Imports

import * as _ from 'underscore'

//#endregion


//#region IMR Imports

import { IIMRPopover, IMRPopoverOptions } from '@imr/controls.angularjs/components/overlay/popover'
import { IIMRPopup, IMRPopupOptions } from '@imr/controls.angularjs/components/overlay/popup'

//#endregion

import { TypeHelper } from '../../../../helpers'

import { IMRBaseOverlayControlController } from '../../base'

import { IMRSelectGridOptions, IIMRSelectGrid, IMRSelectGridInitializedArgs, IMRSelectGridObjectSelected, IMRSelectGridObjectsSelected } from '../select-grid/select-grid.interfaces'
import { IMRSelectGridPopupOptions, IIMRSelectGridPopup } from './select-grid.popup.interfaces'

export class IMRSelectGridPopupController<TObject>
    extends IMRBaseOverlayControlController<IIMRSelectGridPopup<TObject>, IMRSelectGridPopupOptions<TObject>>
    implements IIMRSelectGridPopup<TObject> {

    //#region Members

    private isCloseAfterSelect: boolean
    private isPreserveSelectionOnClose: boolean

    public selectGridOptions: IMRSelectGridOptions<TObject>

    //#endregion


    //#region IIMRSelectGridPopup Implementation

    public getSelectGrid(): IIMRSelectGrid<TObject> {
        return this.selectGrid
    }

    public getPopover(): IIMRPopover {
        return this.popover
    }

    public getPopup(): IIMRPopup {
        return this.popup
    }

    //#endregion


    //#region Lifecycle

    protected initialize(options: IMRSelectGridPopupOptions<TObject>): JQueryPromise<void> {
        return super
            .initialize(options)
            .then(() => {
                this.setDefaults()
                this.setOptions()
            })
    }

    protected customizePopoverOverlay(popoverOptions: IMRPopoverOptions): void {
        popoverOptions.innerOptions.onHidden = TypeHelper.wrapAndCall(popoverOptions.innerOptions.onHidden, e => {
            this.onOverlayHidden(e)
        })

        if (popoverOptions.innerOptions.width == null) {
            popoverOptions.innerOptions.width = 600
        }

        if (popoverOptions.innerOptions.height == null) {
            popoverOptions.innerOptions.height = 600
        }
    }

    protected customizePopupOverlay(popupOptions: IMRPopupOptions): void {
        popupOptions.innerOptions.onHidden = TypeHelper.wrapAndCall(popupOptions.innerOptions.onHidden, e => {
            this.onOverlayHidden(e)
        })

        if (popupOptions.innerOptions.width == null) {
            popupOptions.innerOptions.width = 600
        }

        if (popupOptions.innerOptions.height == null) {
            popupOptions.innerOptions.height = 600
        }
    }

    protected initializeOverlayContent(): JQueryPromise<any> {
        return this.initializeSelectGrid()
    }

    private setDefaults(): void {
        this.isCloseAfterSelect = true
        this.isPreserveSelectionOnClose = false
        this.selectGridOptions = null
    }

    private setOptions(): void {
        if (this.options != null) {
            if (this.options.selectGridOptions != null) {
                this.selectGridOptions = TypeHelper.clone(this.options.selectGridOptions, true)
            }

            if (this.options.popupOptions != null) {
                this.popupOptions = TypeHelper.clone(this.options.popupOptions, true)
            }

            if (this.options.popoverOptions != null) {
                this.popoverOptions = TypeHelper.clone(this.options.popoverOptions, true)
            }

            if (this.options.closeAfterSelect != null) {
                this.isCloseAfterSelect = this.options.closeAfterSelect
            }

            if (this.options.preserveSelectionOnClose != null) {
                this.isPreserveSelectionOnClose = this.options.preserveSelectionOnClose
            }
        }
    }

    //#endregion


    //#region Container

    private onOverlayHidden(e: any) {
        if (this.selectGrid != null) {
            if (!this.isPreserveSelectionOnClose) {
                this.selectGrid.reset()
            }
        }
    }

    //#endregion


    //#region Select Grid

    private selectGrid: IIMRSelectGrid<TObject>

    private initializeSelectGrid() {
        this.selectGridOptions = this.overwriteSelectGridOptions(this.selectGridOptions)

        return super
            .waitForOnInitialized(this.selectGridOptions)
            .then((e: IMRSelectGridInitializedArgs<TObject>) => {
                this.selectGrid = e.component
            })
    }


    private overwriteSelectGridOptions(options: IMRSelectGridOptions<TObject>) {
        if (options == null) {
            options = {} as IMRSelectGridOptions<TObject>
        }

        options.onObjectSelected = TypeHelper.wrapAndCall(options.onObjectSelected, (e: IMRSelectGridObjectSelected<TObject>) => {
            this.onSelected()
        })

        options.onObjectsSelected = TypeHelper.wrapAndCall(options.onObjectsSelected, (e: IMRSelectGridObjectsSelected<TObject>) => {
            this.onSelected()
        })

        return options
    }

    private onSelected(): void {
        if (this.isCloseAfterSelect) {
            if (this.popover != null) {
                this.popover.hide()
            }
            else if (this.popup != null) {
                this.popup.hide()
            }
        }
    }

    //#endregion
}


